import React, { Fragment } from 'react';
import { appStructure } from 'helpers/navigationHelper';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import { Loadable } from 'dataLayer/recoil/Loadable';
import {
  allergyTraitsSelector,
  beProductiveTraitsSelector,
  eatFreshTraitsSelector,
  hairTraitsSelector,
  skinTraitsSelector,
  stayActiveTraitsSelector,
} from 'dataLayer/recoil/pages/sections/selectors';
import RenderSectionProfile from 'pages/RenderSectionProfile/RenderSectionProfile';

const NutritionProfile = (props) => {
  const reportData = {
    report_code: 'nutrition-and-metabolism',
    language: 'en',
  };

  return <RenderSectionProfile data={props.data} reportData={reportData} />;
};

const StayActiveProfile = (props) => {
  const reportData = {
    report_code: 'fitness',
    language: 'en',
  };

  return <RenderSectionProfile data={props.data} reportData={reportData} />;
};

const HairProfile = (props) => {
  const reportData = {
    report_code: 'hair-and-scalp',
    language: 'en',
  };

  return <RenderSectionProfile data={props.data} reportData={reportData} />;
};

const AllergyProfile = (props) => {
  const reportData = {
    report_code: 'allergies-and-sensitivities',
    language: 'en',
  };

  return <RenderSectionProfile data={props.data} reportData={reportData} />;
};

const SkinProfile = (props) => {
  const reportData = {
    report_code: 'skin-care',
    language: 'en',
  };

  return <RenderSectionProfile data={props.data} reportData={reportData} />;
};

const BeProductiveProfile = (props) => {
  const reportData = {
    report_code: 'personality',
    language: 'en',
  };

  return <RenderSectionProfile data={props.data} reportData={reportData} />;
};

export default function MyDnaProfileSection(props) {
  let { path } = useRouteMatch();

  const subsections = appStructure.sections[0].subsections;

  return (
    <Fragment>
      <Switch>
        <Route exact path={path}>
          <Redirect
            to={{
              pathname: subsections[0].route,
            }}
          />
        </Route>
        <Route
          path={subsections[0].route}
          render={() => (
            <Loadable
              value={eatFreshTraitsSelector}
              component={NutritionProfile}
            />
          )}
        />

        <Route
          path={subsections[1].route}
          render={() => (
            <Loadable
              value={stayActiveTraitsSelector}
              component={StayActiveProfile}
            />
          )}
        />

        <Route
          path={subsections[2].route}
          render={() => (
            <Loadable
              value={beProductiveTraitsSelector}
              component={BeProductiveProfile}
            />
          )}
        />

        <Route
          path={subsections[3].route}
          render={() => (
            <Loadable value={skinTraitsSelector} component={SkinProfile} />
          )}
        />

        <Route
          path={subsections[4].route}
          render={() => (
            <Loadable
              value={allergyTraitsSelector}
              component={AllergyProfile}
            />
          )}
        />

        <Route
          path={subsections[5].route}
          render={() => (
            <Loadable value={hairTraitsSelector} component={HairProfile} />
          )}
        />
      </Switch>
    </Fragment>
  );
}
